/* Playcor theme scripts — vanilla JS, no dependencies. */
(function () {
  'use strict';

  var root = document.documentElement;
  var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  var designMode = !!(window.Shopify && window.Shopify.designMode);
  var routes = window.PlaycorRoutes || { cartAdd: '/cart/add', cart: '/cart' };

  function $$(selector, scope) {
    return Array.prototype.slice.call((scope || document).querySelectorAll(selector));
  }

  /* ---------------- Header & menus ---------------- */
  var headerBound = false;
  function setHeaderHeight() {
    var header = document.querySelector('[data-header]');
    if (header) root.style.setProperty('--header-h', header.offsetHeight + 'px');
  }
  function closeDropdowns(except) {
    $$('[data-dropdown-toggle]').forEach(function (btn) {
      if (btn !== except) btn.setAttribute('aria-expanded', 'false');
    });
  }
  function initHeader() {
    var header = document.querySelector('[data-header]');
    if (!header) return;
    setHeaderHeight();

    var toggle = header.querySelector('[data-menu-toggle]');
    var menu = header.querySelector('[data-mobile-menu]');
    if (toggle && menu && !toggle.dataset.ready) {
      toggle.dataset.ready = '1';
      var showPanel = function (name) {
        $$('[data-panel]', menu).forEach(function (p) {
          var on = p.getAttribute('data-panel') === name;
          p.classList.toggle('is-active', on);
          p.classList.toggle('is-left', !on && name !== 'root' && p.getAttribute('data-panel') === 'root');
          p.setAttribute('aria-hidden', on ? 'false' : 'true');
        });
        $$('[data-panel-open]', menu).forEach(function (b) { b.setAttribute('aria-expanded', String(b.getAttribute('data-panel-open') === name)); });
      };
      var closeMenu = function () {
        toggle.setAttribute('aria-expanded', 'false');
        menu.classList.remove('is-open');
        root.classList.remove('menu-open');
        setTimeout(function () { if (!menu.classList.contains('is-open')) { menu.hidden = true; showPanel('root'); } }, 450);
      };
      toggle.addEventListener('click', function () {
        var open = toggle.getAttribute('aria-expanded') === 'true';
        setHeaderHeight();
        if (open) { closeMenu(); return; }
        toggle.setAttribute('aria-expanded', 'true');
        menu.hidden = false;
        root.classList.add('menu-open');
        requestAnimationFrame(function () { menu.classList.add('is-open'); });
      });
      $$('[data-panel-open]', menu).forEach(function (b) {
        b.addEventListener('click', function () { showPanel(b.getAttribute('data-panel-open')); });
      });
      $$('[data-panel-back]', menu).forEach(function (b) {
        b.addEventListener('click', function () { showPanel('root'); });
      });
      window.addEventListener('resize', function () { if (window.innerWidth >= 990 && menu.classList.contains('is-open')) closeMenu(); }, { passive: true });
    }

    $$('[data-dropdown-toggle]', header).forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function () {
        var open = btn.getAttribute('aria-expanded') === 'true';
        closeDropdowns(btn);
        btn.setAttribute('aria-expanded', String(!open));
      });
    });

    if (!headerBound) {
      headerBound = true;
      window.addEventListener('resize', setHeaderHeight, { passive: true });
      document.addEventListener('click', function (e) {
        if (!e.target.closest('.has-dropdown')) closeDropdowns();
        $$('details.filter[open]').forEach(function (d) {
          if (!d.contains(e.target)) d.removeAttribute('open');
        });
      });
      document.addEventListener('keydown', function (e) {
        if (e.key !== 'Escape') return;
        closeDropdowns();
        var t = document.querySelector('[data-menu-toggle][aria-expanded="true"]');
        if (t) { t.click(); t.focus(); }
      });
    }
  }

  /* ---------------- Reveal on scroll ---------------- */
  function initReveal(scope) {
    var els = $$('[data-reveal]:not(.is-visible)', scope);
    if (!els.length) return;
    if (reduceMotion || designMode || !('IntersectionObserver' in window)) {
      els.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          io.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -12% 0px' });
    els.forEach(function (el) { io.observe(el); });
  }

  /* ---------------- Illustration scroll motion ----------------
     Each illustration eases from its start state to rest as its centre
     travels from the bottom of the viewport to the middle. */
  var motionEls = [];
  var motionTicking = false;
  var motionBound = false;
  function updateMotion() {
    motionTicking = false;
    var vh = window.innerHeight || 800;
    motionEls.forEach(function (el) {
      var r = el.getBoundingClientRect();
      if (r.bottom < -300 || r.top > vh + 300) return;
      var p = (vh - (r.top + r.height / 2)) / (vh / 2);
      p = Math.max(0, Math.min(1, p));
      var from = parseFloat(el.getAttribute('data-motion-from')) || 0;
      var type = el.getAttribute('data-motion');
      if (type === 'rotate') el.style.setProperty('--mr', (from * (1 - p)).toFixed(2) + 'deg');
      else if (type === 'scale') el.style.setProperty('--ms', (from + (1 - from) * p).toFixed(3));
      else if (type === 'fade') el.style.setProperty('--mo', p.toFixed(3));
    });
  }
  function requestMotion() {
    if (!motionTicking) { motionTicking = true; window.requestAnimationFrame(updateMotion); }
  }
  function initMotion(scope) {
    var found = $$('[data-motion]', scope);
    if (reduceMotion) {
      found.forEach(function (el) { el.style.setProperty('--mo', '1'); });
      return;
    }
    found.forEach(function (el) { if (motionEls.indexOf(el) === -1) motionEls.push(el); });
    motionEls = motionEls.filter(function (el) { return document.body.contains(el); });
    if (!motionBound && motionEls.length) {
      motionBound = true;
      window.addEventListener('scroll', requestMotion, { passive: true });
      window.addEventListener('resize', requestMotion, { passive: true });
    }
    updateMotion();
  }

  /* ---------------- Slider (testimonials) ---------------- */
  function initSliders(scope) {
    $$('[data-slider]', scope).forEach(function (slider) {
      if (slider.dataset.ready) return;
      slider.dataset.ready = '1';
      var track = slider.querySelector('[data-slider-track]');
      if (!track) return;
      function go(dir) {
        var width = track.clientWidth;
        var max = track.scrollWidth - width;
        var target = track.scrollLeft + dir * width;
        if (dir > 0 && track.scrollLeft >= max - 4) target = 0;
        if (dir < 0 && track.scrollLeft <= 4) target = max;
        track.scrollTo({ left: target, behavior: reduceMotion ? 'auto' : 'smooth' });
      }
      var prev = slider.querySelector('[data-slider-prev]');
      var next = slider.querySelector('[data-slider-next]');
      if (prev) prev.addEventListener('click', function () { go(-1); });
      if (next) next.addEventListener('click', function () { go(1); });
    });
  }

  /* ---------------- Product gallery ---------------- */
  function initGalleries(scope) {
    $$('[data-gallery]', scope).forEach(function (gallery) {
      if (gallery.dataset.ready) return;
      gallery.dataset.ready = '1';
      var track = gallery.querySelector('[data-gallery-track]');
      if (!track) return;
      var thumbs = $$('[data-thumb]', gallery);

      function setActive(id) {
        thumbs.forEach(function (t) {
          var active = t.getAttribute('data-thumb') === String(id);
          t.classList.toggle('is-active', active);
          t.setAttribute('aria-current', active ? 'true' : 'false');
          if (active && t.scrollIntoView && thumbs.length > 6) {
            t.parentNode.scrollTo({ left: t.offsetLeft - 20, behavior: 'smooth' });
          }
        });
      }
      gallery.goTo = function (id, smooth) {
        var slide = gallery.querySelector('[data-media-id="' + id + '"]');
        if (!slide) return;
        track.scrollTo({ left: slide.offsetLeft, behavior: smooth && !reduceMotion ? 'smooth' : 'auto' });
        setActive(id);
      };
      thumbs.forEach(function (t) {
        t.addEventListener('click', function () { gallery.goTo(t.getAttribute('data-thumb'), true); });
      });
      var step = function (dir) {
        track.scrollTo({ left: track.scrollLeft + dir * track.clientWidth, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      var prev = gallery.querySelector('[data-gallery-prev]');
      var next = gallery.querySelector('[data-gallery-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      if ('IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) setActive(entry.target.getAttribute('data-media-id'));
          });
        }, { root: track, threshold: 0.6 });
        $$('[data-media-id]', gallery).forEach(function (s) { io.observe(s); });
      }
      var thumbsWrap = gallery.querySelector('[data-thumbs]');
      var thumbsNext = gallery.querySelector('[data-thumbs-next]');
      if (thumbsWrap && thumbsNext) {
        var checkThumbs = function () { thumbsNext.hidden = thumbsWrap.scrollWidth <= thumbsWrap.clientWidth + 4; };
        thumbsNext.addEventListener('click', function () {
          var atEnd = thumbsWrap.scrollLeft + thumbsWrap.clientWidth >= thumbsWrap.scrollWidth - 4;
          thumbsWrap.scrollTo({ left: atEnd ? 0 : thumbsWrap.scrollLeft + thumbsWrap.clientWidth * 0.8, behavior: reduceMotion ? 'auto' : 'smooth' });
        });
        checkThumbs();
        window.addEventListener('resize', checkThumbs);
      }
      var initial = gallery.getAttribute('data-initial');
      if (initial) window.requestAnimationFrame(function () { gallery.goTo(initial, false); });
    });
  }

  /* ---------------- Product card swatches ---------------- */
  function initCardSwatches(scope) {
    $$('.card-swatch', scope).forEach(function (btn) {
      if (btn.dataset.ready) return;
      btn.dataset.ready = '1';
      btn.addEventListener('click', function (e) {
        e.preventDefault();
        var card = btn.closest('.product-card');
        if (!card) return;
        var img = card.querySelector('.product-card__img:not(.product-card__img--hover)');
        var src = btn.getAttribute('data-img');
        if (img && src && img.getAttribute('src') !== src) {
          img.setAttribute('srcset', btn.getAttribute('data-srcset') || src);
          img.setAttribute('src', src);
          card.classList.add('is-swapped');
        }
        var vid = btn.getAttribute('data-variant');
        if (vid) {
          $$('a[href]', card).forEach(function (a) {
            var href = a.getAttribute('href').split('?')[0];
            a.setAttribute('href', href + '?variant=' + vid);
          });
        }
        $$('.card-swatch', card).forEach(function (b) { b.classList.toggle('is-active', b === btn); });
      });
    });
  }

  /* ---------------- Reels scroller ---------------- */
  function initReels(scope) {
    $$('[data-reels]', scope).forEach(function (el) {
      if (el.dataset.ready) return;
      el.dataset.ready = '1';
      var track = el.querySelector('.ig-reels__track');
      var step = function (dir) {
        var card = track.querySelector('.ig-reel');
        var w = card ? card.getBoundingClientRect().width + 20 : 320;
        track.scrollBy({ left: dir * w * 2, behavior: reduceMotion ? 'auto' : 'smooth' });
      };
      var prev = el.querySelector('[data-reels-prev]');
      var next = el.querySelector('[data-reels-next]');
      if (prev) prev.addEventListener('click', function () { step(-1); });
      if (next) next.addEventListener('click', function () { step(1); });

      var canHover = window.matchMedia && window.matchMedia('(hover: hover)').matches;
      $$('[data-reel]', el).forEach(function (card) {
        var video = card.querySelector('video');
        if (!video) return;
        var play = function () {
          if (video.preload === 'none') { video.preload = 'auto'; }
          var p = video.play();
          if (p && p.then) p.then(function () { card.classList.add('is-playing'); }).catch(function () {});
          else card.classList.add('is-playing');
        };
        var pause = function () { video.pause(); card.classList.remove('is-playing'); };
        if (canHover) {
          card.addEventListener('mouseenter', play);
          card.addEventListener('mouseleave', pause);
          card.addEventListener('focus', play);
          card.addEventListener('blur', pause);
        } else if ('IntersectionObserver' in window) {
          new IntersectionObserver(function (entries) {
            entries.forEach(function (e) { if (e.isIntersecting) play(); else pause(); });
          }, { rootMargin: '-38% 0px -38% 0px', threshold: 0 }).observe(card);
        }
      });
    });
  }

  /* ---------------- Directional button fill ---------------- */
  function initButtonFill(scope) {
    var sel = '.btn, .newsletter-form__button, .shopify-payment-button__button';
    var setPoint = function (e) {
      var r = this.getBoundingClientRect();
      this.style.setProperty('--mx', ((e.clientX - r.left) / r.width * 100).toFixed(1) + '%');
      this.style.setProperty('--my', ((e.clientY - r.top) / r.height * 100).toFixed(1) + '%');
    };
    $$(sel, scope).forEach(function (btn) {
      if (btn.dataset.fill) return;
      btn.dataset.fill = '1';
      btn.addEventListener('mouseenter', setPoint);
      btn.addEventListener('mouseleave', setPoint);
    });
  }

  /* ---------------- Sticky add-to-cart bar ---------------- */
  function initStickyBuy(scope) {
    $$('[data-sticky-buy]', scope).forEach(function (bar) {
      if (bar.dataset.ready) return;
      bar.dataset.ready = '1';
      var section = bar.closest('.main-product');
      var addBtn = section ? section.querySelector('[data-add-button]') : null;
      var form = section ? section.querySelector('[data-product-form]') : null;
      if (!addBtn || !form || !('IntersectionObserver' in window)) return;
      var io = new IntersectionObserver(function (entries) {
        var e = entries[0];
        var below = e.boundingClientRect.top < 0;
        var show = !e.isIntersecting && below;
        bar.hidden = !show;
        requestAnimationFrame(function () { bar.classList.toggle('is-visible', show); });
      }, { threshold: 0 });
      io.observe(addBtn);
      var stickyBtn = bar.querySelector('[data-sticky-add]');
      if (stickyBtn) stickyBtn.addEventListener('click', function () {
        if (addBtn.disabled) { addBtn.scrollIntoView({ behavior: 'smooth', block: 'center' }); return; }
        if (form.requestSubmit) form.requestSubmit(addBtn); else addBtn.click();
      });
    });
  }

  /* ---------------- Back to top ---------------- */
  function initToTop() {
    var btn = document.querySelector('[data-to-top]');
    if (!btn) return;
    var bar = btn.querySelector('.to-top__progress');
    var ticking = false;
    var update = function () {
      ticking = false;
      var max = document.documentElement.scrollHeight - window.innerHeight;
      var y = window.scrollY || window.pageYOffset;
      var pct = max > 0 ? Math.min(1, y / max) : 0;
      if (bar) bar.style.strokeDashoffset = (100 - pct * 100).toFixed(2);
      var show = y > window.innerHeight * 0.9;
      if (show && btn.hidden) { btn.hidden = false; requestAnimationFrame(function () { btn.classList.add('is-in'); }); }
      if (!show && !btn.hidden && !btn.classList.contains('is-launching') && !btn.classList.contains('is-landing')) {
        btn.classList.remove('is-in');
        setTimeout(function () { if (!btn.classList.contains('is-in')) btn.hidden = true; }, 400);
      }
      document.body.classList.toggle('has-sticky-buy', !!document.querySelector('.sticky-buy.is-visible'));
    };
    window.addEventListener('scroll', function () { if (!ticking) { ticking = true; requestAnimationFrame(update); } }, { passive: true });
    update();
    btn.addEventListener('click', function () {
      if (btn.classList.contains('is-launching')) return;
      btn.classList.add('is-launching');
      window.scrollTo({ top: 0, behavior: reduceMotion ? 'auto' : 'smooth' });
      var start = Date.now();
      (function wait() {
        if ((window.scrollY || 0) < 4 || Date.now() - start > 1800) {
          btn.classList.remove('is-launching');
          btn.classList.add('is-landing');
          setTimeout(function () { btn.classList.remove('is-landing'); update(); }, 900);
        } else { requestAnimationFrame(wait); }
      })();
    });
  }

  /* ---------------- Mobile: keep illustrations off the text ---------------- */
  function placeDecorMobile() {
    var mobile = window.innerWidth < 750;
    $$('.section-inner, .media-banner__inner').forEach(function (inner) {
      var decors = $$('.decor', inner);
      if (!decors.length) return;
      decors.forEach(function (d) { d.classList.remove('is-hidden-m', 'is-tucked'); d.style.left = ''; d.style.top = ''; });
      if (!mobile) return;
      var texts = $$('h1, h2, h3, h4, p, li, blockquote, label, input, textarea, select, .btn, .rte', inner)
        .filter(function (el) { return !el.closest('.decor') && el.offsetParent !== null; })
        .map(function (el) { return el.getBoundingClientRect(); })
        .filter(function (r) { return r.width > 0 && r.height > 0; });
      var hits = function (r) {
        var pad = 10;
        return texts.some(function (t) {
          return r.left < t.right + pad && r.right > t.left - pad && r.top < t.bottom + pad && r.bottom > t.top - pad;
        });
      };
      var box = inner.getBoundingClientRect();
      var media = $$('.arch-feature__frame, .contact-section__arch, .product-story__frame, .story-columns__media, .image-row__media, img', inner)
        .filter(function (el) { return !el.closest('.decor'); })
        .map(function (el) { return el.getBoundingClientRect(); })
        .filter(function (r) { return r.width > 120 && r.height > 120; });
      var placed = [];
      decors.forEach(function (d) {
        if (getComputedStyle(d).display === 'none') return;
        var r = d.getBoundingClientRect();
        var clash = function (rr) {
          return hits(rr) || placed.some(function (p) { return rr.left < p.right && rr.right > p.left && rr.top < p.bottom && rr.bottom > p.top; });
        };
        if (!clash(r)) { placed.push(r); return; }
        var w = r.width, h = r.height, tries = [];
        media.forEach(function (m) {
          tries.push([m.right - w * 0.72, m.bottom - h * 0.72]);
          tries.push([m.left - w * 0.28, m.bottom - h * 0.72]);
          tries.push([m.right - w * 0.72, m.top - h * 0.28]);
          tries.push([m.left - w * 0.28, m.top - h * 0.28]);
        });
        tries.push([box.right - w * 0.55, r.top]);
        tries.push([box.left - w * 0.45, r.top]);
        for (var i = 0; i < tries.length; i++) {
          d.style.left = (tries[i][0] - box.left) + 'px';
          d.style.top = (tries[i][1] - box.top) + 'px';
          d.classList.add('is-tucked');
          var nr = d.getBoundingClientRect();
          if (!clash(nr)) { placed.push(nr); return; }
        }
        d.style.left = ''; d.style.top = '';
        d.classList.add('is-hidden-m');
      });
    });
  }

  /* ---------------- Contact forms: "Sign up for news and updates" also joins the Kit list ---------------- */
  function initSignupOptIn() {
    $$('form.contact-form').forEach(function (form) {
      if (form.dataset.optin) return;
      form.dataset.optin = '1';
      form.addEventListener('submit', function () {
        var box = form.querySelector('input[name="contact[Sign up for news and updates]"]');
        var email = form.querySelector('input[name="contact[email]"]');
        if (!box || !box.checked || !email || !email.value) return;
        try {
          var fd = new FormData();
          fd.append('email_address', email.value);
          var first = form.querySelector('input[name="contact[First name]"]');
          if (first && first.value) fd.append('fields[first_name]', first.value);
          var kitId = window.PlaycorKitForm;
          if (kitId && navigator.sendBeacon) navigator.sendBeacon('https://app.kit.com/forms/' + kitId + '/subscriptions', fd);
        } catch (e) {}
      });
    });
  }

  /* ---------------- Welcome pop-up ---------------- */
  function initNewsletterPopup() {
    var pop = document.querySelector('[data-nl-pop]');
    var teaser = document.querySelector('[data-nl-teaser]');
    if (!pop) return;
    var store = {
      get: function (k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } },
      set: function (k, v) { try { window.localStorage.setItem(k, v); } catch (e) {} },
      sget: function (k) { try { return window.sessionStorage.getItem(k); } catch (e) { return null; } },
      sset: function (k, v) { try { window.sessionStorage.setItem(k, v); } catch (e) {} }
    };
    var design = pop.getAttribute('data-design') === 'true';
    var days = parseInt(pop.getAttribute('data-days'), 10) || 7;
    var subscribed = store.get('playcor_nl_subscribed') === '1';
    var dismissedAt = parseInt(store.get('playcor_nl_dismissed') || '0', 10);
    var resting = dismissedAt && (Date.now() - dismissedAt) < days * 864e5;
    var teaserOff = store.get('playcor_nl_teaser_off') === '1';
    var lastFocus = null;
    var opened = false;

    var showTeaser = function () {
      if (!teaser || subscribed || teaserOff || pop.getAttribute('data-teaser') !== 'true') return;
      teaser.hidden = false;
      requestAnimationFrame(function () { teaser.classList.add('is-in'); });
    };
    var hideTeaser = function () { if (teaser) { teaser.classList.remove('is-in'); setTimeout(function () { teaser.hidden = true; }, 500); } };

    var open = function () {
      if (opened) return;
      opened = true;
      lastFocus = document.activeElement;
      hideTeaser();
      pop.hidden = false;
      document.documentElement.classList.add('nl-locked');
      requestAnimationFrame(function () { requestAnimationFrame(function () { pop.classList.add('is-open'); }); });
      store.sset('playcor_nl_seen', '1');
      var dialog = pop.querySelector('.nl-pop__dialog');
      setTimeout(function () { var f = pop.querySelector('input[type="email"]'); if (f && window.innerWidth > 749) f.focus({ preventScroll: true }); else if (dialog) dialog.focus({ preventScroll: true }); }, 700);
    };
    var close = function (remember) {
      pop.classList.remove('is-open');
      document.documentElement.classList.remove('nl-locked');
      setTimeout(function () { pop.hidden = true; opened = false; }, 700);
      if (remember && !subscribed) { store.set('playcor_nl_dismissed', String(Date.now())); }
      if (!subscribed) setTimeout(showTeaser, 900);
      if (lastFocus && lastFocus.focus) lastFocus.focus({ preventScroll: true });
    };

    var confetti = function () {
      var box = pop.querySelector('[data-nl-confetti]');
      if (!box || reduceMotion) return;
      var colours = ['#76715B', '#B29B7D', '#D3DCDD', '#495869', '#C5B49D'];
      var kinds = ['dot', 'pill', 'arc', 'spark', 'dot', 'spark'];
      for (var i = 0; i < 26; i++) {
        var b = document.createElement('span');
        var ang = (Math.PI * 2 * i) / 26 + (Math.random() - 0.5) * 0.4;
        var dist = 70 + Math.random() * 110;
        b.className = 'nl-bit nl-bit--' + kinds[i % kinds.length];
        b.style.background = colours[i % colours.length];
        b.style.setProperty('--dx', (Math.cos(ang) * dist).toFixed(1) + 'px');
        b.style.setProperty('--dy', (Math.sin(ang) * dist * 0.8 + 20).toFixed(1) + 'px');
        b.style.setProperty('--rot', ((Math.random() - 0.5) * 540).toFixed(0) + 'deg');
        b.style.animationDelay = (Math.random() * 0.15).toFixed(2) + 's';
        box.appendChild(b);
        setTimeout(function (el) { return function () { el.remove(); }; }(b), 2000);
      }
    };

    $$('[data-nl-close]', pop).forEach(function (el) { el.addEventListener('click', function () { close(true); }); });
    pop.addEventListener('keydown', function (e) {
      if (e.key === 'Escape') { close(true); return; }
      if (e.key !== 'Tab') return;
      var f = $$('button, input, a[href]', pop).filter(function (x) { return x.offsetParent !== null; });
      if (!f.length) return;
      if (e.shiftKey && document.activeElement === f[0]) { e.preventDefault(); f[f.length - 1].focus(); }
      else if (!e.shiftKey && document.activeElement === f[f.length - 1]) { e.preventDefault(); f[0].focus(); }
    });

    // signed up: swap to the thank-you panel, never show again
    var form = pop.querySelector('form');
    if (form) {
      form.addEventListener('submit', function () {
        var email = form.querySelector('input[type="email"]');
        if (!email || !email.checkValidity()) return;
        subscribed = true;
        store.set('playcor_nl_subscribed', '1');
        setTimeout(function () {
          var a = pop.querySelector('[data-nl-panel="form"]');
          var b = pop.querySelector('[data-nl-panel="done"]');
          if (a && b) { a.hidden = true; b.hidden = false; }
          pop.classList.add('is-done');
          confetti();
        }, 900);
      });
    }

    if (teaser) {
      teaser.addEventListener('click', function (e) {
        if (e.target.closest('[data-nl-teaser-close]')) {
          e.stopPropagation(); store.set('playcor_nl_teaser_off', '1'); teaserOff = true; hideTeaser(); return;
        }
        open();
      });
    }

    if (design) { open(); return; }
    if (subscribed) return;
    if (resting || store.sget('playcor_nl_seen') === '1') { showTeaser(); return; }

    var delay = (parseInt(pop.getAttribute('data-delay'), 10) || 9) * 1000;
    var scrollPct = (parseInt(pop.getAttribute('data-scroll'), 10) || 45) / 100;
    var autoFired = false;
    var timer;
    var onScroll = function () {
      var max = document.documentElement.scrollHeight - window.innerHeight;
      if (max > 0 && window.scrollY / max >= scrollPct) autoOpen();
    };
    var onOut = function (e) { if (!e.relatedTarget && e.clientY <= 0) autoOpen(); };
    var autoOpen = function () {
      if (autoFired) return;
      autoFired = true;
      clearTimeout(timer);
      window.removeEventListener('scroll', onScroll);
      document.removeEventListener('mouseout', onOut);
      open();
    };
    timer = setTimeout(autoOpen, delay);
    window.addEventListener('scroll', onScroll, { passive: true });
    if (pop.getAttribute('data-exit') === 'true' && window.matchMedia('(hover: hover)').matches) {
      document.addEventListener('mouseout', onOut);
    }
  }

  /* ---------------- Cart count ---------------- */
  function refreshCartCount() {
    return fetch(routes.cart + '.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        $$('[data-cart-count]').forEach(function (el) {
          el.textContent = cart.item_count;
          el.hidden = cart.item_count === 0;
        });
        $$('[data-cart-link]').forEach(function (el) {
          el.setAttribute('aria-label', 'Cart, ' + cart.item_count + (cart.item_count === 1 ? ' item' : ' items'));
        });
      })
      .catch(function () {});
  }

  /* ---------------- Product form & variant picker ---------------- */
  function initProducts(scope) {
    $$('[data-product]', scope).forEach(function (wrap) {
      if (wrap.dataset.ready) return;
      wrap.dataset.ready = '1';

      var json = wrap.querySelector('[data-variants]');
      var variants = [];
      try { variants = json ? JSON.parse(json.textContent) : []; } catch (e) { variants = []; }

      var form = wrap.querySelector('[data-product-form]');
      var idInput = form ? form.querySelector('[data-variant-id]') : null;
      var addBtn = form ? form.querySelector('[data-add-button]') : null;
      var addLabel = addBtn ? addBtn.querySelector('[data-add-label]') : null;
      var defaultLabel = addBtn ? (addBtn.getAttribute('data-label') || 'Add to cart') : 'Add to cart';
      var errorEl = form ? form.querySelector('[data-form-error]') : null;
      var gallery = wrap.querySelector('[data-gallery]');
      var fieldsets = $$('[data-option-position]', wrap);
      var scarcity = wrap.querySelector('[data-scarcity]');

      function setButton(enabled, label) {
        if (!addBtn) return;
        addBtn.disabled = !enabled;
        if (addLabel) addLabel.textContent = label;
      }
      function currentOptions() {
        return fieldsets.map(function (fs) {
          var checked = fs.querySelector('input:checked');
          return checked ? checked.value : null;
        });
      }
      function findVariant(opts) {
        for (var i = 0; i < variants.length; i++) {
          var v = variants[i];
          var match = v.options.every(function (o, idx) { return o === opts[idx]; });
          if (match) return v;
        }
        return null;
      }
      function update() {
        var opts = currentOptions();
        fieldsets.forEach(function (fs, i) {
          var out = fs.querySelector('[data-selected-value]');
          if (out) out.textContent = opts[i] || '';
        });
        var v = findVariant(opts);
        if (!v) { setButton(false, 'Unavailable'); return; }
        if (idInput) idInput.value = v.id;

        $$('[data-price-wrap]', wrap).forEach(function (pw) {
          var current = pw.querySelector('[data-price]');
          var compare = pw.querySelector('[data-compare-price]');
          if (current) current.innerHTML = v.price;
          if (compare) {
            compare.innerHTML = v.compare_at_price || '';
            compare.hidden = !v.compare_at_price;
          }
          pw.classList.toggle('price--sale', !!v.compare_at_price);
        });

        setButton(v.available, v.available ? defaultLabel : 'Sold out');
        $$('[data-btn-price]', wrap).forEach(function (el) { el.innerHTML = v.price; });

        if (scarcity) {
          var threshold = parseInt(scarcity.getAttribute('data-threshold'), 10) || 10;
          var count = scarcity.querySelector('[data-scarcity-count]');
          var show = v.available && v.inventory !== null && v.inventory > 0 && v.inventory <= threshold;
          scarcity.hidden = !show;
          if (count && show) count.textContent = v.inventory;
        }

        if (gallery && gallery.goTo && v.media_id) gallery.goTo(v.media_id, true);

        if (window.history && window.history.replaceState) {
          var url = new URL(window.location.href);
          url.searchParams.set('variant', v.id);
          window.history.replaceState({}, '', url.toString());
        }
      }
      fieldsets.forEach(function (fs) { fs.addEventListener('change', update); });

      if (form && window.fetch && window.FormData) {
        form.addEventListener('submit', function (e) {
          e.preventDefault();
          if (!addBtn || addBtn.disabled) return;
          if (errorEl) errorEl.hidden = true;
          addBtn.disabled = true;
          fetch(routes.cartAdd + '.js', {
            method: 'POST',
            headers: { Accept: 'application/json', 'X-Requested-With': 'XMLHttpRequest' },
            body: new FormData(form)
          })
            .then(function (r) { return r.json().then(function (data) { return { ok: r.ok, data: data }; }); })
            .then(function (res) {
              if (!res.ok) throw new Error(res.data.description || res.data.message || 'This item could not be added to your cart.');
              if (addLabel) addLabel.textContent = 'Added!';
              refreshCartCount();
              setTimeout(function () {
                if (addLabel) addLabel.textContent = defaultLabel;
                addBtn.disabled = false;
              }, 1800);
            })
            .catch(function (err) {
              if (errorEl) { errorEl.textContent = err.message; errorEl.hidden = false; }
              addBtn.disabled = false;
            });
        });
      }
    });
  }

  /* ---------------- Quantity steppers, cart, filters ---------------- */
  var qtyBound = false;
  function initQuantity() {
    if (qtyBound) return;
    qtyBound = true;
    document.addEventListener('click', function (e) {
      var btn = e.target.closest('[data-qty-step]');
      if (!btn) return;
      var input = btn.parentNode.querySelector('input');
      if (!input) return;
      var min = parseInt(input.getAttribute('min'), 10);
      if (isNaN(min)) min = 0;
      var next = (parseInt(input.value, 10) || 0) + parseInt(btn.getAttribute('data-qty-step'), 10);
      input.value = Math.max(min, next);
      input.dispatchEvent(new Event('change', { bubbles: true }));
    });
  }
  function initCart(scope) {
    $$('[data-cart-form]', scope).forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('change', function (e) {
        if (e.target.matches('[data-cart-qty]')) form.submit();
      });
    });
  }
  function initFilters(scope) {
    $$('[data-filter-form]', scope).forEach(function (form) {
      if (form.dataset.ready) return;
      form.dataset.ready = '1';
      form.addEventListener('change', function () {
        $$('input[type="number"]', form).forEach(function (input) {
          if (input.value === '') input.disabled = true;
        });
        form.submit();
      });
    });
  }

  /* ---------------- Background video: respect reduced motion ---------------- */
  function initVideos(scope) {
    if (!reduceMotion) return;
    $$('.media-bg video[autoplay]', scope).forEach(function (v) {
      v.removeAttribute('autoplay');
      v.pause();
      if (v.getAttribute('poster')) v.classList.add('is-paused');
    });
  }

  /* ---------------- Boot ---------------- */
  function initAll(scope) {
    initVideos(scope);
    initReveal(scope);
    initMotion(scope);
    initSliders(scope);
    initGalleries(scope);
    initCardSwatches(scope);
    initButtonFill(scope);
    initStickyBuy(scope);
    initReels(scope);
    initProducts(scope);
    initCart(scope);
    initFilters(scope);
  }

  function boot() {
    root.classList.remove('no-js');
    root.classList.add('js');
    initHeader();
    initQuantity();
    initAll(document);
    initToTop();
    initSignupOptIn();
    initNewsletterPopup();
    var decorTimer;
    var runDecor = function () { clearTimeout(decorTimer); decorTimer = setTimeout(placeDecorMobile, 150); };
    window.addEventListener('load', runDecor);
    window.addEventListener('resize', runDecor, { passive: true });
    runDecor();
    setTimeout(function () { initButtonFill(document); }, 1200);
    setTimeout(function () { initButtonFill(document); }, 3000);
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();

  /* Theme editor support */
  document.addEventListener('shopify:section:load', function (e) {
    initHeader();
    initAll(e.target);
  });
  document.addEventListener('shopify:block:select', function (e) {
    var slide = e.target.closest('.testimonial');
    var track = slide && slide.closest('[data-slider-track]');
    if (track) track.scrollTo({ left: slide.offsetLeft, behavior: 'auto' });
  });
})();
